import React, { useEffect, useState } from "react";
import { ALLOWED_FILE_EXTENSIONS } from "../constants";
import "./index.scss";

interface DragOverlayProps {
  isDragging: boolean;
}

const DragOverlay: React.FC<DragOverlayProps> = ({ isDragging }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isDragging) {
      setIsVisible(true);
      if (timer) clearTimeout(timer);
    } else {
      timer = setTimeout(() => {
        setIsVisible(false);
      }, 100);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isDragging]);

  if (!isDragging && !isVisible) return null;

  return (
    <div className={`drag-overlay ${isVisible ? "visible" : "fading"}`}>
      <div className="drag-message">
        <div className="drag-icon">
          <svg
            width="60"
            height="60"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="#ad56d5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12 8V16"
              stroke="#ad56d5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8 12L12 8L16 12"
              stroke="#ad56d5"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p>Drop files here to upload</p>
        <div className="allowed-file-types">
          <p>Supported file types:</p>
          <p className="file-extensions">
            {ALLOWED_FILE_EXTENSIONS.join(", ")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DragOverlay;
